
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/basketball",
      function () {
        return require("private-next-pages/sneakers/basketball.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/basketball"])
      });
    }
  